export const QUERY_KEYS = {
    banners: {
        all: ["banners"] as const,
        active: ["banners", "active"] as const,
        list: ["banners", "list"] as const
    }
} as const;
